import { http } from '@/api/http';

import type { Locale, LocaleFormValues } from './types';

export function fetchLocales(): Promise<Locale[]> {
  return http.getPage<Locale>('/admin/locales').then((page) => page.items);
}

export function createLocale(values: LocaleFormValues): Promise<Locale> {
  return http.post<Locale>('/admin/locales', payloadFromForm(values, true));
}

export function updateLocale(id: number, values: LocaleFormValues): Promise<Locale> {
  return http.put<Locale>(`/admin/locales/${id}`, payloadFromForm(values, false));
}

export function deleteLocale(id: number): Promise<void> {
  return http.delete(`/admin/locales/${id}`);
}

function payloadFromForm(values: LocaleFormValues, includeCode: boolean): Record<string, unknown> {
  const payload: Record<string, unknown> = {
    name: values.name,
    native_name: values.native_name,
    url_prefix: values.url_prefix ? values.url_prefix : null,
    hreflang: values.hreflang || values.code,
    og_locale: values.og_locale || values.code,
    direction: values.direction,
    is_default: values.is_default,
    is_active: values.is_active,
    is_visible: values.is_visible,
    sort_order: values.sort_order,
  };

  if (includeCode) {
    payload.code = values.code;
  }

  return payload;
}
